import { Container } from 'inversify';

import { PolicyCheckingService } from 'src/app/bookings/shared/policy-checking.service';
import { CalculatePriceService } from 'src/app/bookings/shared/calculate-prices.service';
import { ErratasService } from 'src/app/bookings/shared/erratas.service';
import { ConfirmationQuoteService } from 'src/app/bookings/shared/confirmation-quote.service';
import { TaxonomyService } from './shared/taxonomy.service';

export function setup(container: Container) {
	container.bind(PolicyCheckingService).toSelf();
	container.bind(CalculatePriceService).toSelf();
	container.bind(ErratasService).toSelf();
	container.bind(ConfirmationQuoteService).toSelf();
	container.bind(TaxonomyService).toSelf();
}



// WEBPACK FOOTER //
// ./src/app/bookings/bookings.config.ts